import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5552d344"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CountryFilterWrapper" }
const _hoisted_2 = { class: "RefineContentOptionsList" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "lnr-plus" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountryCheckbox = _resolveComponent("CountryCheckbox")!
  const _component_Areas = _resolveComponent("Areas")!
  const _component_TrackedMultiSelect = _resolveComponent("TrackedMultiSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryFilterOptions, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.optionValue
        }, [
          _createVNode(_component_CountryCheckbox, {
            optionName: item.optionName,
            optionValue: item.optionValue,
            hasAreas: item.hasAreas,
            class: _normalizeClass({ Indented: !item.hasAreas })
          }, null, 8 /* PROPS */, ["optionName", "optionValue", "hasAreas", "class"]),
          (item.hasAreas)
            ? (_openBlock(), _createBlock(_component_Areas, {
                key: 0,
                countryId: item.optionValue,
                onAreaFilterChange: _ctx.processAreaFilterChange
              }, null, 8 /* PROPS */, ["countryId", "onAreaFilterChange"]))
            : _createCommentVNode("v-if", true)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    (!_ctx.showMultiselect)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "AddCountry",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.displayMultiselect && _ctx.displayMultiselect(...args)))
        }, [
          _hoisted_3,
          _createTextVNode(" Add")
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.showMultiselect)
      ? (_openBlock(), _createBlock(_component_TrackedMultiSelect, {
          key: 1,
          options: _ctx.transformedCountryFormat,
          label: "",
          placeholder: "Add country",
          searchable: true,
          filterKey: _ctx.key,
          onUpdated: _ctx.onSelect
        }, null, 8 /* PROPS */, ["options", "filterKey", "onUpdated"]))
      : _createCommentVNode("v-if", true)
  ]))
}